import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@uw-env/environment";
import { Observable, map } from 'rxjs';
import { CatalogMaintenanceResponse, CreateCatalogMaintenanceRequest, CreateUpdateDeleteCatalogMaintenanceResponse, DeleteCatalogMaintenanceRequest, UpdateCatalogMaintenanceRequest } from "../api/models";


@Injectable({
  providedIn: "root"
})
export class CatalogMaintenanceService {

  constructor(
    private readonly _client: HttpClient
  ) { }

  search(name: string, value: string): Observable<CatalogMaintenanceResponse[]> {
    const url = `${environment.apiURL}/administration/catalogMgmt/search/maintenance/${name}/${value}`;
    return this._client.get<{ data: CatalogMaintenanceResponse[] }>(url).pipe(
      map(res => res.data)
    );
  }

  get(): Observable<CatalogMaintenanceResponse[]> {
    // City
    // Prov
    // ALL
    // DRCode
    // SUWID
    return this.search('Prov', 'ON');
  }

  getById(recordId: number): Observable<CatalogMaintenanceResponse> {
    return this.get().pipe(
      map(CatalogMaintenances => CatalogMaintenances.find(x => x.recordId == recordId)!)
    )
  }

  create(request: CreateCatalogMaintenanceRequest): Observable<CreateUpdateDeleteCatalogMaintenanceResponse[]> {
    const url = `${environment.apiURL}/administration/catalogMgmt/create/maintenance`;
    return this._client.post<{ data: CreateUpdateDeleteCatalogMaintenanceResponse[] }>(url, request).pipe(
      map(res => res.data)
    )
  }

  update(request: UpdateCatalogMaintenanceRequest): Observable<CreateUpdateDeleteCatalogMaintenanceResponse[]> {
    const url = `${environment.apiURL}/administration/catalogMgmt/update/maintenance`;
    return this._client.post<{ data: CreateUpdateDeleteCatalogMaintenanceResponse[] }>(url, request).pipe(
      map(res => res.data)
    )
  }

  delete(request: DeleteCatalogMaintenanceRequest): Observable<CreateUpdateDeleteCatalogMaintenanceResponse[]> {
    const url = `${environment.apiURL}/administration/catalogMgmt/delete/maintenance`;
    return this._client.post<{ data: CreateUpdateDeleteCatalogMaintenanceResponse[] }>(url, request).pipe(
      map(res => res.data)
    )
  }
}